import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/components/WebView/icons/More.svg'


const _withScopeId = n => (_pushScopeId("data-v-7ced080a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "more"
}, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "time-options"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Time Filter", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "label" }
const _hoisted_6 = {
  key: 0,
  class: "check"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "time-range-container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.opened = !_ctx.opened))
  }, [
    _hoisted_1,
    (_ctx.opened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${option.timeRange.timeUnit}-${option.timeRange.timeValue}`,
              class: _normalizeClass(['option', { active: _ctx.isOptionSelected(option) }]),
              onClick: ($event: any) => (_ctx.$emit('selectTime', option.timeRange))
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(option.label), 1),
              (_ctx.isOptionSelected(option))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_FontAwesomeIcon, { icon: _ctx.faCheck }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, () => (_ctx.opened = false)]
  ])
}